import { GlobalContext } from "contexts/GlobalContext";
import { useContext, useEffect, useState } from "react";
import { DivTooltip } from "./DivTooltip";
import { ISaveFile, useSaveFile } from "hooks/useSaveFile";
import { useHistory } from "react-router-dom";
import { RouteList } from "Routes";

export const GamesList = () => {
    const { commonData, setSelectedGame } = useContext(GlobalContext);

    const history = useHistory();
    const { getSaveFiles, removeSaveFile } = useSaveFile();

    const [showInactiveGames, setShowInactiveGames] = useState(false);
    const [saveFiles, setSaveFiles] = useState<Array<ISaveFile>>([]);

    useEffect(() => {
        setSaveFiles(getSaveFiles());
    }, [getSaveFiles]);

    return (
        <div className="vstack gap-4">
            <div className="vstack flex-lg-row flex-wrap gap-2 justify-content-center text-center text-lg-start">
                {commonData?.games
                    .filter(g => showInactiveGames || g.activePlayerCount)
                    .map(g => (
                        <DivTooltip title={g.name} placement="bottom" key={g.id}>
                            <button
                                type="button"
                                className="btn btn-primary icon-link"
                                onClick={() => {
                                    setSelectedGame(g);
                                    history.push(RouteList.Analyse(g.id));
                                }}
                            >
                                <img alt="" src={g.imageUrl} width={45} height={15} />
                                {g.name}
                            </button>
                        </DivTooltip>
                    ))}
            </div>

            {commonData?.games.some(g => !g.activePlayerCount) && !showInactiveGames && (
                <button
                    type="button"
                    className="btn btn-link"
                    onClick={() => {
                        setShowInactiveGames(true);
                    }}
                >
                    Show inactive games
                </button>
            )}

            {saveFiles.length > 0 && (
                <div className="vstack gap-2 text-center">
                    <div className="h5">Save files</div>

                    <div className="vstack gap-2">
                        {saveFiles.map(x => (
                            <div className="hstack gap-2 align-self-center" key={x.name}>
                                <button
                                    type="button"
                                    className="btn btn-link p-0"
                                    onClick={() => {
                                        history.push(x.url);
                                    }}
                                >
                                    {x.name}
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-link p-0 text-danger"
                                    onClick={() => {
                                        removeSaveFile(x.name);

                                        setSaveFiles(getSaveFiles());
                                    }}
                                >
                                    <span className="fa fa-trash"></span>
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
